import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Brands from './Brands';
import CarModels from './CarModels';
import CarVariants from './CarVariants';
import CarServiceCenters from './CarServiceCenters';
import CarDealers from './CarDealers';
import Icon from '../components/Icon';

const styles = {
  container: {
    width: '100%'
  },
  header: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#1e293b',
    margin: 0
  },
  subtitle: {
    fontSize: '13px',
    color: '#64748b',
    marginTop: '2px'
  },
  tabsWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: '20px',
    padding: '6px',
    backgroundColor: '#f1f5f9',
    borderRadius: '12px',
    width: 'fit-content'
  },
  tabsContainer: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    overflow: 'hidden'
  },
  tabContent: {
    padding: '16px',
    minHeight: '400px'
  }
};

const getTabStyle = (isActive, isHovered) => ({
  padding: '10px 18px',
  fontSize: '13px',
  fontWeight: isActive ? '600' : '500',
  color: isActive ? '#ffffff' : '#64748b',
  backgroundColor: isActive ? '#4f46e5' : (isHovered ? '#e2e8f0' : 'transparent'),
  border: 'none',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  boxShadow: isActive ? '0 2px 8px rgba(79, 70, 229, 0.3)' : 'none'
});

const tabs = [
  { id: 'brands', label: 'Brands', icon: 'tag' },
  { id: 'models', label: 'Models', icon: 'car' },
  { id: 'variants', label: 'Variants', icon: 'list' },
  { id: 'service-centers', label: 'Service Centers', icon: 'wrench' },
  { id: 'dealers', label: 'Dealers', icon: 'store' }
];

function CarsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [hoveredTab, setHoveredTab] = useState(null);
  const activeTab = searchParams.get('tab') || 'brands';

  const handleTabChange = (tabId) => {
    setSearchParams({ tab: tabId });
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'brands':
        return <Brands />;
      case 'models':
        return <CarModels />;
      case 'variants':
        return <CarVariants />;
      case 'service-centers':
        return <CarServiceCenters />;
      case 'dealers':
        return <CarDealers />;
      default:
        return <Brands />;
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>Car Management</h1>
          <p style={styles.subtitle}>Manage car brands, models, variants, service centers and dealers</p>
        </div>
      </div>

      <div style={styles.tabsWrapper}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            style={getTabStyle(activeTab === tab.id, hoveredTab === tab.id)}
            onClick={() => handleTabChange(tab.id)}
            onMouseEnter={() => setHoveredTab(tab.id)}
            onMouseLeave={() => setHoveredTab(null)}
          >
            <Icon name={tab.icon} size={15} style={{ pointerEvents: 'none' }} />
            <span style={{ pointerEvents: 'none' }}>{tab.label}</span>
          </button>
        ))}
      </div>

      <div style={styles.tabsContainer}>
        <div style={styles.tabContent}>
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
}

export default CarsPage;
